// Which design language the office app draws in: the company's design.language setting, as
// branding.theme reports it (its tokenSet). Blueprint, the default, unless a company's setting says
// riverstone; in Blueprint the app sits in the Blueprint frame (Frame.tsx) and each screen's Header
// draws only its title block.
import { createContext, useContext } from 'react';

export type Design = 'riverstone' | 'blueprint';

export const DesignContext = createContext<Design>('riverstone');

export const useDesign = (): Design => useContext(DesignContext);

/**
 * The crumb over a screen's title in Blueprint (pages/ux-full's .crumb): the frame works it out from
 * places.ts and the Header draws it, so Nav.tsx needn't import places.ts (which imports Nav.tsx).
 * `first` is the place's first page this person opens; on it, the crumb is the place alone.
 */
export interface Crumb {
  place: string;
  /** The first page's screen, and its part where it has one (Accounting's is Books' Overview). */
  first: string | null;
  firstPart?: string | null;
  page: string;
}
export const CrumbContext = createContext<Crumb | null>(null);

/** The design a theme's token set draws: Blueprint only when the server says so. */
export const designOf = (tokenSet: string | undefined): Design =>
  tokenSet === 'blueprint' ? 'blueprint' : 'riverstone';
